import { render, staticRenderFns } from "./adminedit.vue?vue&type=template&id=25d680a4&scoped=true"
import script from "./adminedit.vue?vue&type=script&lang=js"
export * from "./adminedit.vue?vue&type=script&lang=js"
import style0 from "./adminedit.vue?vue&type=style&index=0&id=25d680a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d680a4",
  null
  
)

export default component.exports